import "./style.scss";

import { FormControlLabel, Popover, Radio, RadioGroup } from "@mui/material";
import SortDescent from "assets/img/svg/sortDescent";
import type { FilterOrder } from "components/shared/ElementList/sortStorage";
import { SmallBodyHighlight } from "helpers/TypographyComponents";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import variables from "../../../../assets/styles/_variables.module.scss";

interface OrderFilter {
    orderOptions: { name: string; label: string }[];
    onSelection: any;
    chosenOrder: FilterOrder;
}

const OrderFilter = ({ orderOptions, onSelection, chosenOrder }: OrderFilter) => {
    const [t] = useTranslation();

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, from: "type" | "order") => {
        const newChosenOrder = {
            sortBy: from === "type" ? event.currentTarget.value : chosenOrder.sortBy,
            sortOrder: from === "order" ? event.currentTarget.value : chosenOrder.sortOrder,
        };
        onSelection(newChosenOrder);
    };

    return (
        <div className="order-filter">
            <button onClick={handleClick} className="order-filter-btn">
                <SortDescent />
            </button>
            <Popover
                className="order-filter-popover"
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorEl={anchorEl}
                elevation={0}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <div className="order-filter-container">
                    <SmallBodyHighlight style={{ color: variables["secondary-grey"] }}>
                        {t("Filters.OrderType")}
                    </SmallBodyHighlight>
                    <RadioGroup
                        className="order-filter-options"
                        defaultValue={chosenOrder.sortBy}
                        onChange={(e) => handleChange(e, "type")}
                    >
                        {orderOptions.map((option: { name: string; label: string }, index) => (
                            <FormControlLabel
                                value={option.name}
                                control={<Radio />}
                                label={option.label}
                                key={`option-${index}`}
                            />
                        ))}
                    </RadioGroup>

                    <SmallBodyHighlight style={{ color: variables["secondary-grey"], marginTop: "1rem" }}>
                        {t("Filters.OrderBy")}
                    </SmallBodyHighlight>
                    <RadioGroup
                        className="order-filter-options"
                        defaultValue={chosenOrder.sortOrder.toLowerCase()}
                        onChange={(e) => handleChange(e, "order")}
                    >
                        <FormControlLabel value={"asc"} control={<Radio />} label={t("Filters.Ascending")} />
                        <FormControlLabel value={"desc"} control={<Radio />} label={t("Filters.Descending")} />
                    </RadioGroup>
                </div>
            </Popover>
        </div>
    );
};

export default OrderFilter;
